// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__2i_p5","inline":"styles_inline__o5dIJ"};